<div class="pm-container">
  <div class="pm-header">
    <div class="pm-icon">
      <mat-icon>{{ icon }}</mat-icon>
    </div>
    <div class="pm-copy">
      <h2 class="pm-title">{{ title }}</h2>
      @if (description) {
        <p class="pm-description">{{ description }}</p>
      }
    </div>
  </div>

  <div class="pm-body">
    <mat-form-field appearance="outline" class="pm-field">
      <mat-label>{{ label }}</mat-label>
      @if (multiline) {
        <textarea
          matInput
          [(ngModel)]="promptValue"
          [placeholder]="placeholder"
          [rows]="rows"
          cdkFocusInitial
        ></textarea>
      } @else {
        <input
          type="text"
          matInput
          [(ngModel)]="promptValue"
          [placeholder]="placeholder"
          (keyup.enter)="accept()"
          cdkFocusInitial
        />
      }
    </mat-form-field>
  </div>

  <div class="pm-actions">
    <button class="pm-btn pm-btn--cancel" (click)="close()">
      {{ cancelText }}
    </button>
    <button
      class="pm-btn pm-btn--accept"
      (click)="accept()"
      [disabled]="isSubmitDisabled"
    >
      {{ acceptText }}
    </button>
  </div>
</div>
